module.exports = __webpack_public_path__ + "img/optic.80f67f26.jpg";